import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { TealiumAnalytics } from './tealium.action';
import { tap } from 'rxjs/operators';
import { TealiumEvent, TealiumService } from '../tealium-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class TealiumActionhandler {
  constructor(private actions$: Actions, private _tealium: TealiumService) {}

  initTealium$ = this.actions$
    .pipe(
      ofActionSuccessful(TealiumAnalytics.InitTealiumAction),
      tap(() => {
        this._tealium.init();
      })
    )
    .subscribe(() => {
      // console.log(`${TealiumEvent.INIT} is called`);
    });

  emailQuote$ = this.actions$
    .pipe(
      ofActionSuccessful(TealiumAnalytics.EmailQuoteAction),
      tap(() => {
        //loop-130: https://nibgroup.atlassian.net/browse/LOOP-130
        // email_your_quote is deleted in the frontend and will be tracked in the serverside.
        //this._tealium.trackEvent(TealiumEvent.EMAIL_YOUR_QUOTE);
        this._tealium.trackEvent(TealiumEvent.SUBSCRIBE_MAILING_LIST);
      })
    )
    .subscribe(() => {
      // console.log(`${TealiumEvent.EMAIL_YOUR_QUOTE} is called`);
    });
}
